import { usePriceList } from '@zenbusiness/application-commons-pricelist';

// There are some products that uses different service codes for monthly and annual plans, that leads to a bug since the service name is the same for both but we need to filter by interval. i.e: There is only zb_money_pro, zb_money_pro_month and zb_money_pro_year does not exist on the current price list.
const productsWithIntervalMap = {
  zb_money_pro_month: 'zb_money_pro',
  zb_money_pro_year: 'zb_money_pro'
};

export const useProductPrice = (service, interval, enabledCoupon = null) => {
  const { priceListUuid, get } = usePriceList();

  if (!priceListUuid) {
    return { amount: 0, interval: null };
  }

  const serviceNameToUse = productsWithIntervalMap[service] || service;

  const product = get(serviceNameToUse, interval ? { interval } : { interval: 'annual' });

  if (!product) {
    return { amount: 0, interval: null };
  }

  // Original pricing values
  const originalAmount = product.pricing?.price || 0;
  const productInterval = product?.pricing?.interval || null;
  const fees = product?.pricing?.fees || null;

  // Coupon calculation (only if coupon is provided)
  let finalAmount = originalAmount;
  if (enabledCoupon?.amount) {
    finalAmount = Math.max(originalAmount - enabledCoupon.amount, 0);
  }

  return {
    amount: finalAmount,
    enabledCoupon,
    fees,
    interval: productInterval,
    originalAmount
  };
};
